<div class="header-filters-row" *ngIf="isCreateFromTemplate"
  [ngClass]="{'header-filters-row-scroll': data.length > 3}">
  <div class="main-wrapper">
    <div class="uploader-clear-reject-container">
      <div class="uplaod-title lato-14-n-vw">Upload Preview:</div>
      <div class="total-cleared-container lato-14-n-vw"><span
          class="total-cleared">{{clearedRowsCount}}</span>
        Cleared</div>
      <div class="total-failed-container lato-14-n-vw" *ngIf="failedRows.length"><span
          class="total-failed">{{failedRows.length}}</span>
        Failed:</div>
      <div class="failed-list-wrapper">
        <ng-container *ngFor="let row of failedRows.slice(0,2); let i= index">
          <span class="lato-14-n-vw">#{{row+1}},</span>
        </ng-container>
      </div>
      <div class="more-btn lato-14-n-vw" *ngIf="failedRows.length > 3"
        (click)="openRejectedListModal(eseTemplateHeader,eseTemplateContent,eseTemplateFooter)">
        more...</div>
    </div>
    <div class="search-box">
      <div class="search-icon" cygovSvgIcon [svgName]="'search-icon'">
      </div>
      <input type="text" placeholder="Search" class="lato-14-n-vw" [(ngModel)]="searchQuery"
        (ngModelChange)="filterQuestions()">
    </div>

  </div>
  <div class="downloade-button" (click)="onDownload()" [ngClass]="{'pointer-class':data.length}">
    <div class="down-icon abs-centre" cygovSvgIcon [svgName]="'arrow-down-type3'"></div>
    <span class="lato-14-n-vw">Download</span>
  </div>
</div>
<div class="ese-table-container"
  [ngClass]="{'ess-table-container-vendor-listing': isFromVendorListing}">

  <div class="table-container">
    <div class="scroll-arrows">
      <div class="arrow-right-wrapper" (click)="scrollRight()"
        [ngClass]="{'disabled-arrow' : isRightArrowDisabled}">
        <div class="arrow-right" cygovSvgIcon [svgName]="'arrow-right-type1'"></div>
      </div>
      <div class="arrow-left-wrapper" (click)="scrollLeft()"
        [ngClass]="{'disabled-arrow' : isLeftArrowDisabled || isUploaderActive}">
        <div class="arrow-left" cygovSvgIcon [svgName]="'arrow-left-type1'"></div>
      </div>
    </div>

    <table class="table-responsive" #tableWrapper [ngClass]="{'hide-scroll' : isUploaderActive}"
      [style.height]="isCreateFromTemplate && !isUploaderActive ? '35vh !important' : '56vh !important'">
      <thead>
        <tr class="header-row">
          <th class="header-item-checkbox">

          </th>
          <th *ngFor="let header of headerItemsESE; let i= index" class="header-items">
            <ng-container *ngIf="!header.isGroup">
              <div class="single-header-item lato-16-n-vw" [style.width]="header.width"
                [style.maxWidth]="header.width">
                <div [attr.rowspan]="2"
                  [ngStyle]="{'color': header.sortDirection==='asc' ? '' : '#29a9eb'}">{{
                  header.name }}</div>
                <div class="sort-icon" *ngIf="header.isSortApplicable" cygovSvgIcon
                  [svgName]="'arrow-sort'"
                  [ngClass]="{'dsc' : header.sortDirection==='asc'?false:true}"
                  (click)="!isUploaderActive && sortData(header.name,i,header.sortDirection)"></div>
              </div>
            </ng-container>
            <ng-container *ngIf="header.isGroup">
              <div [attr.colspan]="header.children.length" [style.width]="header.width"
                [style.maxWidth]="header.width" [ngClass]="{'header-nested-th' : header.isGroup}"
                class="lato-16-n-vw">
                {{ header.name }}
              </div>

        <tr class="header-nested-row" colspan="2">
          <th *ngFor="let c of header.children, let cIndex = index" class="nested-items"
            [ngStyle]="{'border-right': cIndex === 0 ? '3px solid #000517' : ''}">
            <div class="single-nested-item" [style.width]="c.width" [style.maxWidth]="c.width">
              <div class="lato-16-n-vw"
                [ngStyle]="{'color': c.sortDirection==='asc' ? '' : '#29a9eb'}">
                {{c.name}}
              </div>
              <div class="sort-icon" *ngIf="c.isSortApplicable" cygovSvgIcon
                [svgName]="'arrow-sort'" [ngClass]="{'dsc' : c.sortDirection==='asc'?false:true}"
                (click)="!isUploaderActive && sortData(header.name + ' ' +c.name,i,c.sortDirection,cIndex)">
              </div>

            </div>
          </th>
        </tr>
        </ng-container>
        </th>
        </tr>
      </thead>
      <!-- While the questionnaire loads, the body is skeleton rows built from the same headers the
           thead above renders, so the placeholders line up with the real columns. -->
      <tbody *ngIf="isLoading">
        <tr class="body-row skeleton-row" *ngFor="let row of skeletonRows">
          <td class="body-item-checkbox">
            <div class="checkbox-wrapper">
              <cygov-skeleton width="1.8vh" height="1.8vh" radius="2px"></cygov-skeleton>
            </div>
          </td>
          <ng-container *ngFor="let header of headerItemsESE">
            <td *ngIf="!header.isGroup" [style.width]="header.width"
              [style.maxWidth]="header.width">
              <div class="td-inner-skeleton">
                <cygov-skeleton [width]="skeletonWidthFor(header.name)" height="1.6vh">
                </cygov-skeleton>
              </div>
            </td>
            <ng-container *ngIf="header.isGroup">
              <td *ngFor="let child of header.children" [style.width]="child.width"
                [style.maxWidth]="child.width">
                <div class="td-inner-skeleton">
                  <cygov-skeleton width="60%" height="1.6vh"></cygov-skeleton>
                </div>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </tbody>
      <tbody *ngIf="!isLoading">
        <ng-container *ngFor="let q of data; let i = index">
          <tr class="body-row">
            <td class="body-item-checkbox">
              <div class="checkbox-wrapper">
                <cygov-checkbox class="ese-list-checkbox" [isChecked]="q[keysObject.isSelected]"
                  [id]="'vendor-'+i" [disable]="false" [width]="20" [height]="20"
                  (changed)="selectRow(i,$event)">
                </cygov-checkbox>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode ,'selected-row' : q[keysObject.isSelected]}">
              {{ q[keysObject.questionNumber] }}
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode ,'error-border':validationErrors[i][keysObject.function],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.function] }}

              </div>
              <div *ngIf="isEditMode">
                <input type="text" class="text-filed lato-14-n-vw" [value]="q[keysObject.function]"
                  (input)="update($event,keysObject.function,i)">
              </div>

            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode, 'error-border':validationErrors[i][keysObject.category],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.category] }}

              </div>
              <div *ngIf="isEditMode" class="text-area-wrapper-div">
                <textarea class="text-area-filed lato-14-n-vw" [value]="q[keysObject.category]"
                  (input)="update($event,keysObject.category,i)"></textarea>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.subCategory],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-center">
                {{ q[keysObject.subCategory] }}
              </div>
              <div *ngIf="isEditMode">
                <input type="text" class="text-filed lato-14-n-vw text-center"
                  (input)="update($event,keysObject.subCategory,i)"
                  [value]="q[keysObject.subCategory]" />
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.controlName],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-center">
                {{ q[keysObject.controlName] }}
              </div>
              <div *ngIf="isEditMode">
                <input type="text" class="text-filed lato-14-n-vw text-center"
                  [value]="q[keysObject.controlName]"
                  (input)="update($event,keysObject.controlName,i)" />
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.controlLabel],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.controlLabel] }}
              </div>
              <div *ngIf="isEditMode" class="text-area-wrapper-div">
                <textarea type="text" class="text-area-filed lato-14-n-vw"
                  [value]="q[keysObject.controlLabel]"
                  (input)="update($event,keysObject.controlLabel,i)"></textarea>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.question],'selected-row' : q[keysObject.isSelected]}"
              [ngStyle]="{'position' : showMoreState[i]?.question ? 'relative' : ''}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.question]?.length > 170 ?
                q[keysObject.question]?.split('').splice(0,170).join('') :
                q[keysObject.question] }}
                <span *ngIf="q[keysObject.question]?.length > 170" class="more-less"
                  (click)="toggleShowMore($event, i, 'question')">
                  more...</span>
              </div>
              <ng-container
                *ngTemplateOutlet="showMoreTemplate; context: { data: q[keysObject.question], obj: q,index : i, type : 'question'}">
              </ng-container>
              <div *ngIf="isEditMode" class="text-area-wrapper-div">
                <textarea type="text" class="text-area-filed lato-14-n-vw"
                  [value]="q[keysObject.question]"
                  (input)="update($event,keysObject.question,i)"></textarea>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.remediationTask],'selected-row' : q[keysObject.isSelected]}"
              [ngStyle]="{'position' : showMoreState[i]?.remediationTask ? 'relative' : ''}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.remediationTask]?.length > 170 ?
                q[keysObject.remediationTask]?.split('').splice(0,170).join('') :
                q[keysObject.remediationTask] }}
                <span *ngIf="q[keysObject.remediationTask]?.length > 170" class="more-less"
                  (click)="toggleShowMore($event, i, 'remediationTask')">
                  more...</span>
              </div>
              <ng-container
                *ngTemplateOutlet="showMoreTemplate; context: { data: q[keysObject.remediationTask], obj: q,index : i, type : 'remediationTask'}">
              </ng-container>
              <div *ngIf="isEditMode" class="text-area-wrapper-div">
                <textarea type="text" class="text-area-filed lato-14-n-vw"
                  [value]="q[keysObject.remediationTask]"
                  (input)="update($event,keysObject.remediationTask,i)"></textarea>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.supplementedGuide],'selected-row' : q[keysObject.isSelected]}"
              [ngStyle]="{'position' : showMoreState[i]?.supplementalGuide ? 'relative' : ''}">
              <div *ngIf="!isEditMode" class="view-mode-text-left">
                {{ q[keysObject.supplementedGuide]?.length > 70 ?
                q[keysObject.supplementedGuide]?.split('').splice(0,70).join('') :
                q[keysObject.supplementedGuide] }}
                <span *ngIf="q[keysObject.supplementedGuide]?.length > 70" class="more-less"
                  (click)="toggleShowMore($event, i, 'supplementalGuide')">
                  more...</span>
              </div>
              <ng-container
                *ngTemplateOutlet="showMoreTemplate; context: { data: q[keysObject.supplementedGuide], obj: q,index : i, type : 'supplementalGuide' }">
              </ng-container>

              <div *ngIf="isEditMode" class="text-area-wrapper-div">
                <textarea type="text" class="text-area-filed lato-14-n-vw"
                  [value]="q[keysObject.supplementedGuide]"
                  (input)="update($event,keysObject.supplementedGuide,i)"></textarea>
              </div>
            </td>
            <td
              [ngClass]="{'edit-mode-borders' : isEditMode,'error-border':validationErrors[i][keysObject.severity],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="!isEditMode" class="view-mode-text-left capitalizeFirstLetter">
                {{ q[keysObject.severity] }}
              </div>
              <div *ngIf="isEditMode">
                <div class="weight">
                  <cygov-select [items]="severityList" [clearable]="false" [searchable]="false"
                    [standardSelect]="true" [customArrow]="true"
                    [(ngModelValue)]="q[keysObject.severity]"
                    (ngModelValueChange)="onSelectionChange($event,keysObject.severity,i)"></cygov-select>
                </div>
                <!-- <input type="text" class="text-filed lato-14-n-vw" [value]="q[keysObject.severity]"
                  (input)="update($event,keysObject.severity,i)" /> -->
              </div>
            </td>
            <td class="p-0">
          <tr class="body-nested-row">
            <td class="body-nested-item"
              [ngClass]="{'edit-mode-borders edit-mode-borders-without-top' : isEditMode,'error-border':validationErrors[i][keysObject.mandatoryArtifacts],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="isEditMode" class="nested-select-wrapper">
                <div class="weight">
                  <cygov-select [items]="booleanOptions" [clearable]="false" [searchable]="false"
                    [standardSelect]="true" [customArrow]="true" [(ngModelValue)]="q[keysObject.mandatoryArtifacts]"
                    (ngModelValueChange)="onSelectionChange($event,keysObject.mandatoryArtifacts,i)"></cygov-select>
                </div>
              </div>
              <div *ngIf="!isEditMode" class="view-mode-text-center">
                {{q[keysObject.mandatoryArtifacts] }}</div>
            </td>
            <td class="body-nested-item"
              [ngClass]="{'edit-mode-borders edit-mode-borders-without-top' : isEditMode,'error-border':validationErrors[i][keysObject.mandatoryComments],'selected-row' : q[keysObject.isSelected]}">
              <div *ngIf="isEditMode" class="nested-select-wrapper">
                <div class="weight">
                  <cygov-select [items]="booleanOptions" [clearable]="false" [searchable]="false"
                    [standardSelect]="true" [customArrow]="true" [(ngModelValue)]="q[keysObject.mandatoryComments]"
                    (ngModelValueChange)="onSelectionChange($event,keysObject.mandatoryComments,i)"></cygov-select>
                </div>
              </div>
              <div *ngIf="!isEditMode" class="view-mode-text-center">
                {{q[keysObject.mandatoryComments]}}</div>
            </td>
          </tr>
          </td>
          <td
            [ngClass]="{'edit-mode-borders' : isEditMode,'selected-row' : q[keysObject.isSelected]}">

            <div class="upload-template-icon-wrapper" (click)="isEditMode && toggleUploader(i)"
              *ngIf="!q[keysObject.template]">
              <div class="upload-template-icon" cygovSvgIcon
                [svgName]="'download-exfiles-icon-white'"></div>
            </div>
            <div class="uplaoded-icon-wrapper" *ngIf="q[keysObject.template]">
              <div class="uploaded-template-icon" cygovSvgIcon [svgName]="'other'"></div>
              <div class="cross-icon lato-12-l-vw" *ngIf="isEditMode" (click)="removeFile(i)">
                X
              </div>
            </div>
          </td>
          </tr>
          <div *ngIf="q?.isUploaderOpen && isEditMode" class="upload-template-main-container">
            <div class="upload-wrapper">
              <div class="cross-icon lato-20-l-vw" (click)="closeUploader(i)">
                X
              </div>
              <div class="upload-outer-container">
                <div class="centetral-container">
                  <div class="upload-body" *ngIf="uploaderStepIndex===0">
                    <div class="icon-upload-cloud" cygovSvgIcon [svgName]="'upload_collection'">
                    </div>
                    <img class="upload-cloud-img" src="assets/images/cloud-new.png"
                      alt="Cloud Upload" />
                    <div id="caller" class="upload-label lato-18-n-vw text-white">
                      Drag files here or
                      <label class="browse-text" for="file">browse</label>
                      <input class="hide-input-file" type="file" id="file" multiple
                        (change)="uploadArtifact($event,i)" />
                    </div>
                  </div>

                  @if (uploaderStepIndex === 1) {
                  <div class="upload-progress-wrapper">
                    @for (file of uploadedFiles; track file.name) {
                    <div class="upload-progress-body">
                      <div class="doc-type-icon">
                        <cygov-username-icon [document]="true"
                          [docFormat]="getFileExtension(file.name)" [height]="'6'"
                          [deleteFlag]="false"></cygov-username-icon>
                      </div>
                      <div class="progress-bar-container">
                        <div class="uploaded-file-name lato-16-n-vw text-white">{{ file.name }}
                        </div>
                        <cygov-progress-bar [assessmentLevel]="progressValues[0]" [height]="10"
                          [width]="24" [postFill]="['#29A9EB', '#29A9EB', '#084871F2']"
                          [preFill]="'#000819'"></cygov-progress-bar>
                      </div>
                    </div>
                    <div class="horizontal-separator"></div>
                    }
                  </div>
                  }
                  <!-- @for (file of uploadedFiles; let i = $index; track file.name) {
                    <div class="upload-progress-body " *ngIf="uploaderStepIndex===1">
                      <div class="doc-type-icon">
                        <cygov-username-icon [document]="true"
                          [docFormat]="getFileExtension(file.name)" [height]="'6'"
                          [deleteFlag]="false">
                        </cygov-username-icon>
                      </div>
                      <div class="progress-bar-container">
                        <div class="uploaded-file-name lato-16-n-vw text-white">
                          {{file.name}}</div>
                        <cygov-progress-bar [assessmentLevel]="progressValues[0]" [height]="10"
                          [width]="24" [postFill]="['#F53D7D']">
                        </cygov-progress-bar>
                      </div>
                    </div>
                    } -->
                  @if(uploaderStepIndex === 2){
                  <div class="upload-acknowledge-body">
                    <div class="acknowledge-texts">
                      <div class="upload-progress-wrapper">
                        @for (file of uploadedFiles; let j = $index; track file.name) {
                        <div class="upload-progress-body">
                          <div class="delete-file-icon">
                            <span class="close-icon lato-20-n-vw"
                              (click)="removeFile(i, j)">×</span>
                          </div>
                          <div class="doc-type-icon">
                            <cygov-username-icon [document]="true"
                              [docFormat]="getFileExtension(file.name)" [height]="'6'"
                              [deleteFlag]="false"></cygov-username-icon>
                          </div>
                          <div class="progress-bar-container">
                            <div class="uploaded-file-name lato-16-n-vw text-white">{{ file.name
                              }}
                            </div>
                            <!-- <div class="uploaded-file-size lato-16-n-vw">{{ file.size }}
                            </div> -->
                          </div>
                        </div>
                        <div class="horizontal-separator"></div>

                        }
                      </div>
                    </div>
                  </div>
                  }
                  <!-- <div class="upload-acknowledge-body" *ngIf="uploaderStepIndex===2">
                    <div class="tick-icon" cygovSvgIcon [svgName]="'complete-popup'"></div>
                    <div class="acknowledge-texts">
                      <div class="file-name lato-18-n-vw text-white">{{q[keysObject.template]}}
                      </div>
                      <div class="succes-text lato-18-n-vw">Uploaded Successfully!</div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

        </ng-container>
      </tbody>
    </table>

    <!-- Kept in the DOM while the body is skeletons rather than removed, because
         updateAddButtonPosition() places it by id and would not find it otherwise. It has no real
         rows to sit under yet, so it waits out of sight instead of landing among the placeholders. -->
    <div *ngIf="!hideAddButton" class="add-question-button" id="addQuestionButton"
      [ngStyle]="{'visibility' : isUploaderActive || isLoading ? 'hidden' : 'visible'}">
      <div class="btn-wrapper" (click)="addRow()">
        <div class="plus-icon" cygovSvgIcon [svgName]="'add-icon'"></div>
        <div class="add-text lato-16-n-vw">Add Question</div>
      </div>
    </div>
  </div>
</div>
<ng-template #showMoreTemplate let-data="data" let-obj="obj" let-index="index" let-type="type">
  <div class="control-details-popup" *ngIf="showMoreState[index]?.[type]" [ngStyle]="{
    'margin-top': isAfterMid ? '-30vh' : '-10vh'
}">
    <div class="description-content lato-16-n-vw">
      {{data}} <span (click)="toggleShowMore($event, index,type)" class="more-less">less</span>
    </div>
  </div>
</ng-template>

<ng-template #eseTemplateHeader>
  <!-- Empty for filters -->
</ng-template>

<ng-template #eseTemplateContent>
  <div class='d-flex justify-content-center flex-column ese-template-upload-failed-popup-content'>
    <span class='lato-20-n-vw text-white text-center'>There was an issue uploading the following
      rows, <br>
      Please try again:
    </span>
    <div class="horizontal-seprator"></div>
    <div class="failed-list-container-wrapper">
      <div class="failed-list-container">
        <ng-container *ngFor="let row of failedRows">

          <div class="failed-item lato-16-n-vw">#{{row+1}}</div>
        </ng-container>
      </div>
    </div>
    <div class="horizontal-seprator"></div>
  </div>
</ng-template>

<ng-template #eseTemplateFooter>
  <div class='ese-template-upload-failed-popup-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'RETRY'" [buttonWidth]="'5vw'"
      [textSize]="'14'" [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'"
      [buttonHeight]="'2.963vh'" (click)="openCreatFromTemplateModal()"></cygov-button>
    <cygov-button class="button-margin" [buttonText]="'CANCEL'" [buttonColor]="'#030715'"
      [buttonBorder]="'#C5C9D1'" [buttonWidth]="'5vw'" [textColor]="'#C5C9D1'"
      (click)="closeModal()">
    </cygov-button>
  </div>

</ng-template>